// extracted by mini-css-extract-plugin
export default {"inspirationalQuote":"inpirationalQuote_inspirationalQuote__csGIL"};